// bao migrate skip

import * as ko from "knockout";
import Badge2 from "./badge2/badge2";
import baoapp from "./bao-app/bao-app";
import baoapp2 from "./bao-app2/bao-app2";
import columnlayout from "./columnlayout/column-layout";
import emailpicker from "./emailpicker/email-picker";
import LoadingComponent from "./loading/loading";
import LoginPage from "./login-page/login-page";
import pager from "./pager/pager";
import Toolbar from "./toolbar/toolbar";
import baoToolTip from "./tooltip/tooltip";
import BaoBadge from "./view-models/bao-badge";
import BaoColorPicker from "./view-models/bao-color-picker";
import BaoColorPalette from "./view-models/bao-color-palette";
import baoUserTagging from "./user-tagging/user-tagging";
import baogrid from "./grid/grid";
import dateTimePicker from "./date-time-picker/date-time-picker";
import selectMultiple from "./select-multiple/select-multiple";
import FinitoBaoBadge2 from "./view-models/finito-bao-badge2";
import FinitoUploadBadge from "./view-models/finito-upload-badge";
import evaluationSearcher from "../checkware/components/evaluation-searcher";
import favouriteControl from "./favourite-control/favourite-control";
import tableControl from "./table-control/table-control";

ko.components.register("bao-colorPicker", BaoColorPicker);
ko.components.register("bao-colorPalette", BaoColorPalette);
ko.components.register("bao-badge", BaoBadge);
ko.components.register("bao-badge2", Badge2);
ko.components.register("bao-column-layout", columnlayout);
ko.components.register("bao-pager", pager);
ko.components.register("bao-tooltip", baoToolTip);
ko.components.register("bao-e-mail-picker", emailpicker);
ko.components.register("bao-app", baoapp);
ko.components.register("bao-app2", baoapp2);
ko.components.register("bao-user-tagging",baoUserTagging);
ko.components.register("bao-grid", baogrid);
ko.components.register("bao-date-time-picker", dateTimePicker);
ko.components.register("bao-select-multiple", selectMultiple);
ko.components.register("bao-loading", LoadingComponent);
ko.components.register("bao-toolbar", Toolbar);
ko.components.register("bao-login", LoginPage);
ko.components.register("finito-bao-badge2", FinitoBaoBadge2);
ko.components.register("finito-upload-badge", FinitoUploadBadge);
ko.components.register("evaluation-searcher", evaluationSearcher);
ko.components.register("table-control", tableControl);
ko.components.register("favourite-control", favouriteControl);
